import {FC, useEffect, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {PageTitle} from '../../../../_metronic/layout/core'
import {Loading} from '../../../components/Loading/Loading'
import {GET, POST, PUT} from '../../../services/api'
import {i18n} from '../../../translate/i18n'
import Swal from 'sweetalert2'
import {ModalWrapper} from '../../../components/Modals/General/ModalWrapper/ModalWrapper'
import useModals from '../../../hooks/useModals'
import {convertBrazilToUTC, telephoneNoMask} from '../../../utils/formater'
import {Button} from '../../../components/Button/Button'
import {BreadCrumbs} from '../../../components/BreadCrumbs/breadCrumbrs'
import {QueueCard} from '../../../components/QueueCard/QueueCard'
import {Input} from '../../../components/Input/Input'
import {AllocationsList} from '../../../components/AllocationsList/AllocationsList'
import {exportExcel} from '../../../utils/utils'
import {Clock} from 'lucide-react'

type QueueType = {
  id: string
  position: number
  minutesOnQueue: string
  people: number
  name: string
  phone: string
  seconds: number
  createdAt: Date
  preferential: boolean
  finalized: 'confirmed' | 'removed' | null
  entryTime: string | null
  updatedAt: string | null
}

type QueueConfig = {
  id: string
  able: boolean
  limitTime: number
  limitPeople: number
  limitPeopleGroup: number
  pluginspaceId: number
  createdAt: string
  updatedAt: string
  observation: string
  useTerms: boolean
  useLocation: boolean
  useMenu: boolean
  useNinegridMenu: boolean
  externalMenuLink: string
  limitQueue: number
  useTableManagement: boolean
}

const QueueContent: FC = () => {
  const navigate = useNavigate()
  const {showWrapperModal, closeWrapperModal} = useModals()
  const [loading, setLoading] = useState(false)
  const [, setLoadingNewData] = useState(false)
  const [queues, setQueues] = useState<QueueType[]>([])
  const [queueSelected, setQueueSelected] = useState<QueueType | null>(null)
  const [limitMinutes, setLimitMinutes] = useState(0)
  const [option, setOption] = useState<'removed' | 'confirmed' | 'add' | 'edit' | 'export_csv'>(
    'removed'
  )
  const [queueConfigId, setQueueConfigId] = useState()
  const [statusFilter, setStatusFilter] = useState<'all' | 'confirmed' | 'removed' | 'queue'>(
    'queue'
  )
  const [preferentialFilter, setPreferentialFilter] = useState<'all' | 'y' | 'n'>('all')
  const [timeFilter, setTimeFilter] = useState<'all' | '12' | '24'>('all')
  const [, setTotalPeopleQueue] = useState(0)

  /* Variavel para função do CSV */
  const [startDate, setStartDate] = useState('')
  const [startHour, setStartHour] = useState('')
  const [finishDate, setFinishDate] = useState('')
  const [finishHour, setFinishHour] = useState('')

  const [queueConfig, setQueueConfig] = useState<QueueConfig>()

  //variavel utilizada para adicionar cliente a fila
  const [customerName, setCustomerName] = useState<string>('')
  const [customerPhone, setCustomerPhone] = useState<string>('')
  const [peopleNumber, setPeopleNumber] = useState<number>(0)
  const [preferentialQueue, setPreferentialQueue] = useState<boolean>(false)

  // States para modal de SELEÇÃO de ambiente e horário (antes de propor)
  const [showAllocationSelectionModal, setShowAllocationSelectionModal] = useState(false)
  const [allocationEnvironmentId, setAllocationEnvironmentId] = useState<number | null>(null)
  const [allocationBookingHourId, setAllocationBookingHourId] = useState<number | null>(null)
  const [allocationBookingHour, setAllocationBookingHour] = useState<any | null>(null) // Objeto completo da hora
  const [environments, setEnvironments] = useState<any[]>([])
  const [bookingHours, setBookingHours] = useState<any[]>([])
  const [loadingEnvironmentsHours, setLoadingEnvironmentsHours] = useState(false)

  // States para modal de alocação de mesas (PROPOSTA)
  const [showAllocationModal, setShowAllocationModal] = useState(false)
  const [allocationProposals, setAllocationProposals] = useState<any[]>([])
  const [selectedProposal, setSelectedProposal] = useState<number | null>(null)
  const [loadingAllocation, setLoadingAllocation] = useState(false)
  const [allocationError, setAllocationError] = useState<string | null>(null)

  // States para visualizar alocações histórico
  const [allocations, setAllocations] = useState<any[]>([])
  const [loadingAllocations, setLoadingAllocations] = useState(false)
  const [timeRangeHours, setTimeRangeHours] = useState(2) // Default: 2 horas para trás e para frente

  const calcTimeSubstractHour = (hour: number) => {
    const newDate = new Date(new Date().getTime() - hour * 3600 * 1000)
    return newDate.toISOString()
  }

  // Carregar ambientes e horários quando o modal de seleção abre
  const loadEnvironmentsAndHours = async () => {
    try {
      setLoadingEnvironmentsHours(true)
      const [envRes, hoursRes] = await Promise.all([
        GET('/queueReservation/bookingEnvironment'),
        GET('/queueReservation/bookingHour'),
      ])

      if (envRes?.success && envRes.data) {
        setEnvironments(envRes.data)
        if (!allocationEnvironmentId && envRes.data.length > 0) {
          setAllocationEnvironmentId(envRes.data[0].id)
        }
      }

      if (hoursRes?.success && hoursRes.data) {
        // Filtrar horários a partir do AGORA (horário atual em diante)
        const now = new Date()
        const currentHour = now.getHours()
        const currentMinutes = now.getMinutes()

        const futureHours = hoursRes.data.filter((h: any) => {
          const [hh, mm] = h.hour.split(':').map(Number)
          // Incluir horários iguais ou maiores ao horário atual
          return hh > currentHour || (hh === currentHour && mm >= currentMinutes)
        })

        setBookingHours(futureHours)
        if (!allocationBookingHourId && futureHours.length > 0) {
          setAllocationBookingHourId(futureHours[0].id)
        }
      }
    } catch (e) {
      console.log('Erro ao carregar ambientes e horários:', e)
    } finally {
      setLoadingEnvironmentsHours(false)
    }
  }

  // Abrir modal de SELEÇÃO (antes de propor)
  const openAllocationSelectionModal = (queue: QueueType) => {
    setQueueSelected(queue)
    setAllocationEnvironmentId(null)
    setAllocationBookingHourId(null)
    setAllocationBookingHour(null)
    setShowAllocationSelectionModal(true)
    loadEnvironmentsAndHours()
  }

  // Propor alocação com ambiente + horário selecionados
  const proposeTableAllocation = async () => {
    if (!queueSelected) {
      setAllocationError('Nenhuma fila selecionada')
      return
    }
    if (!allocationEnvironmentId) {
      setAllocationError('Ambiente não selecionado')
      return
    }
    if (!allocationBookingHourId) {
      setAllocationError('Horário não selecionado')
      return
    }
    try {
      setLoadingAllocation(true)
      setAllocationError(null)
      setShowAllocationSelectionModal(false) // Fechar modal de seleção

      // Log de debug
      const selectedEnv = environments.find((e) => e.id === allocationEnvironmentId)
      const selectedHour = bookingHours.find((h) => h.id === allocationBookingHourId)
      console.log('[Queue] Propondo alocação:', {
        queueId: queueSelected.id,
        peopleCount: queueSelected.people,
        environmentId: allocationEnvironmentId,
        environmentName: selectedEnv?.name,
        bookingHourId: allocationBookingHourId,
        bookingHour: selectedHour?.hour,
      })

      const res = await POST(`/queue-allocation/propose/${queueSelected.id}/${queueConfigId}`, {
        environmentId: allocationEnvironmentId,
        bookingHourId: allocationBookingHourId,
      })

      // Log de resposta
      console.log('[Queue] Resposta do backend:', {
        success: res?.success,
        proposalsCount: res?.data?.length,
        environments: res?.data?.map((p: any) => `${p.environmentName} (ID: ${p.environmentId})`),
      })

      if (res && res.success && res.data) {
        setAllocationProposals(res.data)
        setShowAllocationModal(true)
        if (res.data.length > 0) {
          setSelectedProposal(0)
        }
      } else {
        setAllocationError(res?.message || 'Erro ao propor alocação de mesas')
        Swal.fire({
          customClass: {
            container: 'my-swal',
          },
          icon: 'error',
          title: 'Erro!',
          text: res?.message || 'Falha ao propor alocação de mesas',
        })
      }
    } catch (e) {
      console.log(e)
      const errorMsg = e && typeof e === 'string' ? e : 'Erro ao propor alocação'
      setAllocationError(errorMsg)
      Swal.fire({
        customClass: {
          container: 'my-swal',
        },
        icon: 'error',
        title: 'Erro!',
        text: errorMsg,
      })
    } finally {
      setLoadingAllocation(false)
    }
  }

  const confirmTableAllocation = async () => {
    if (!queueSelected || selectedProposal === null) {
      setAllocationError('Proposta não selecionada')
      return
    }
    try {
      setLoadingAllocation(true)
      setAllocationError(null)
      const proposal = allocationProposals[selectedProposal]

      // Construir dateAllocation: DATA + HORA exata no formato "YYYY-MM-DD HH:MM"
      // Exemplo: "2025-12-30 01:00"
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')

      // ✅ CRÍTICO: Obter a hora exata selecionada
      // Deve ter sido salva em allocationBookingHour quando selecionou na modal
      const selectedHour =
        allocationBookingHour || bookingHours.find((h) => h.id === allocationBookingHourId)
      const hourString = selectedHour?.hour || '00:00' // Formato: "HH:MM"

      // Debug MUITO detalhado para entender por que não está pegando a hora
      console.log('[Queue] ===== DEBUG: Pegando a hora selecionada =====')
      console.log('[Queue] allocationBookingHourId:', allocationBookingHourId)
      console.log('[Queue] allocationBookingHour:', allocationBookingHour)
      console.log('[Queue] allocationBookingHour?.hour:', allocationBookingHour?.hour)
      console.log('[Queue] bookingHours array:', bookingHours)
      console.log('[Queue] bookingHours length:', bookingHours.length)

      if (allocationBookingHourId) {
        const foundHour = bookingHours.find((h) => h.id === allocationBookingHourId)
        console.log('[Queue] Tentando encontrar hora com ID:', allocationBookingHourId)
        console.log('[Queue] Hora encontrada:', foundHour)
        console.log('[Queue] Tipo de ID procurado:', typeof allocationBookingHourId)
        console.log(
          '[Queue] Tipos de ID no array:',
          bookingHours.map((h) => ({id: h.id, type: typeof h.id, hour: h.hour}))
        )
      }

      console.log('[Queue] selectedHour final:', selectedHour)
      console.log('[Queue] hourString final:', hourString)
      console.log('[Queue] ===== FIM DEBUG =====\n')

      // ✅ FORMATO CORRETO: "YYYY-MM-DD HH:MM" (data + hora exata)
      // Exemplo: "2025-12-30 01:00"
      // O Backend deve interpretar isso como LOCAL TIME, não UTC
      const dateAllocation = `${year}-${month}-${day} ${hourString}`

      console.log('[Queue] confirmTableAllocation - dateAllocation CONSTRUÍDO:', {
        date: `${year}-${month}-${day}`,
        time: hourString,
        dateAllocation,
      })

      console.log('[Queue] confirmTableAllocation - Payload being sent:', {
        queueId: queueSelected.id,
        selectedTableIds: proposal.tableIds,
        environmentId: proposal.environmentId,
        dateAllocation,
      })

      const res = await POST(`/queue-allocation/confirm/${queueSelected.id}`, {
        selectedTableIds: proposal.tableIds,
        environmentId: proposal.environmentId,
        dateAllocation,
      })
      setLoadingAllocation(false)
      if (res && res.success) {
        setShowAllocationModal(false)
        setAllocationProposals([])
        setSelectedProposal(null)
        closeWrapperModal() // Fecha a modal de confirmação também
        Swal.fire({
          customClass: {
            container: 'my-swal',
          },
          icon: 'success',
          title: 'Sucesso!',
          text: 'Alocação de mesa confirmada com sucesso',
        }).then(() => {
          // NÃO chamar changeQueue() aqui - deixar a confirmação de chegada para depois
          // A alocação de mesa é um passo anterior à confirmação de chegada
          getQueues()
          // Buscar alocações atualizadas
          fetchAllocations(timeRangeHours)
        })
      } else {
        setAllocationError(res?.message || 'Erro ao confirmar alocação de mesas')
        Swal.fire({
          customClass: {
            container: 'my-swal',
          },
          icon: 'error',
          title: 'Erro!',
          text: res?.message || 'Falha ao confirmar alocação de mesas',
        })
      }
    } catch (e) {
      setLoadingAllocation(false)
      console.log(e)
      const errorMsg = e && typeof e === 'string' ? e : 'Erro ao confirmar alocação'
      setAllocationError(errorMsg)
      Swal.fire({
        customClass: {
          container: 'my-swal',
        },
        icon: 'error',
        title: 'Erro!',
        text: errorMsg,
      })
    }
  }

  const fetchAllocations = async (hours: number = 2) => {
    try {
      setLoadingAllocations(true)
      const now = new Date()
      const startTime = new Date(now.getTime() - hours * 60 * 60 * 1000) // X horas no passado
      const endTime = new Date(now.getTime() + hours * 60 * 60 * 1000) // X horas no futuro

      const res = await GET(
        `/queue-allocation/allocations?startTime=${startTime.toISOString()}&endTime=${endTime.toISOString()}`
      )

      if (res && res.success && res.data) {
        setAllocations(res.data)
      } else {
        setAllocations([])
      }
    } catch (e) {
      console.log('Erro ao buscar alocações:', e)
      setAllocations([])
    } finally {
      setLoadingAllocations(false)
    }
  }

  const getQueues = async () => {
    try {
      const res = await GET('/queueReservation/queueConfig')
      if (res.success && res.data && res.data[0] && res.data[0].id && res.data[0].limitTime) {
        const queueConfigId = res.data[0].id
        setQueueConfig(res.data[0])
        setLimitMinutes(res.data[0].limitTime)
        if (queueConfigId) {
          setQueueConfigId(res.data[0].id)
          const queuesRes = await GET(
            `/queueReservation/queue/${queueConfigId}?status=${statusFilter}&preferential=${preferentialFilter}&timeInitial=${
              timeFilter !== 'all' ? calcTimeSubstractHour(parseInt(timeFilter)) : timeFilter
            }`
          )
          if (queuesRes && queuesRes.data && queuesRes.data.length > 0) {
            let totalPeopleQueueAux = 0
            const queuesData = queuesRes.data.map((queue: QueueType) => {
              const seconds =
                parseInt(queue.minutesOnQueue.split(':')[0]) * 3600 +
                parseInt(queue.minutesOnQueue.split(':')[1]) * 60 +
                parseInt(queue.minutesOnQueue.split(':')[2])
              queue.seconds = seconds
              totalPeopleQueueAux += queue.people
              return queue
            })
            setQueues(queuesData)
            setTotalPeopleQueue(totalPeopleQueueAux)
          } else {
            setQueues([])
          }
        } else {
          Swal.fire({
            customClass: {
              container: 'my-swal',
            },
            icon: 'error',
            title: 'Erro!',
            text: 'Não foi possível encontrar configuração de fila',
          }).then(() => navigate('/queue/config'))
        }
      } else {
        Swal.fire({
          customClass: {
            container: 'my-swal',
          },
          icon: 'error',
          title: 'Erro!',
          text: 'É necessário configurar a fila antes de receber os dados',
        }).then(() => navigate('/queue/config'))
      }
    } catch (e) {
      console.log(e)
      Swal.fire({
        customClass: {
          container: 'my-swal',
        },
        icon: 'error',
        title: 'Erro!',
        text: e && typeof e === 'string' ? e : 'Erro ao carregar fila de espera',
      })
    }
  }

  const changeQueue = async () => {
    if (queueSelected) {
      const queue = Object.assign(queueSelected)
      const opt = option.toString()
      setQueueSelected(null)
      setOption('confirmed')
      try {
        setLoading(true)
        const res = await PUT(`/queueReservation/queue/${queue.id}`, {
          entryTime: new Date(),
          finalized: opt,
        })
        await getQueues()
        setLoading(false)
        if (res && res.success) {
          Swal.fire({
            customClass: {
              container: 'my-swal',
            },
            icon: 'success',
            title: 'Fila alterada!',
            text:
              opt === 'removed' ? 'Removido da fila com sucesso' : 'Chegada confirmada com sucesso',
          })
        } else {
          Swal.fire({
            customClass: {
              container: 'my-swal',
            },
            icon: 'error',
            title: 'Erro!',
            text: 'Falha ao alterar fila',
          })
        }
      } catch (e) {
        setLoading(false)
        console.log(e)
        Swal.fire({
          customClass: {
            container: 'my-swal',
          },
          icon: 'error',
          title: 'Erro!',
          text: 'Falha ao alterar fila',
        })
      }
    } else {
      Swal.fire({
        customClass: {
          container: 'my-swal',
        },
        icon: 'error',
        title: 'Erro!',
        text: 'Falha ao alterar fila',
      })
    }
  }

  const updateAll = async (finalized: string) => {
    try {
      Swal.fire({
        customClass: {
          container: 'my-swal',
        },
        icon: 'warning',
        title:
          finalized === 'removed'
            ? 'Você tem certeza que deseja remover todas as pessoas da fila?'
            : 'Você tem certeza que deseja confirmar todas as pessoas da fila?',
        showCloseButton: true,
        showCancelButton: true,
        reverseButtons: false,
        cancelButtonColor: '#dc3741',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
      }).then(async (result) => {
        if (result.isConfirmed) {
          setLoading(true)
          const res = await POST(`/queueReservation/queue/update-all`, {
            ids: queues.filter((queue) => !queue.finalized).map((queue) => queue.id),
            finalized,
          })
          setLoading(false)
          if (res && res.success) {
            Swal.fire({
              customClass: {
                container: 'my-swal',
              },
              icon: 'success',
              title: 'Filas alteradas!',
              text:
                finalized === 'removed'
                  ? 'Filas removidas com sucesso'
                  : 'Filas confirmadas com sucesso',
            }).then(() => setQueues([]))
          } else {
            Swal.fire({
              customClass: {
                container: 'my-swal',
              },
              icon: 'error',
              title: 'Erro!',
              text: 'Falha ao alterar filas',
            }).then(async () => window.location.reload())
          }
        }
      })
    } catch (e) {
      setLoading(false)
      console.log(e)
      Swal.fire({
        customClass: {
          container: 'my-swal',
        },
        icon: 'error',
        title: 'Erro!',
        text: 'Falha ao alterar filas',
      }).then(async () => window.location.reload())
    }
  }

  const init = async () => {
    setLoading(true)
    await getQueues()
    setLoading(false)
  }

  async function getQueue() {
    try {
      const elementLoading = document.getElementById('loading-all')
      if (queueConfigId && !elementLoading) {
        let newStatusFilter = statusFilter.toString()
        let newPreferentialFilter = preferentialFilter.toString()
        let newTimeFilter = timeFilter.toString()
        const elementStatus: any = document.getElementById('status-filter-input')
        const elementPreferential: any = document.getElementById('preferential-filter-input')
        const elementTime: any = document.getElementById('time-filter-input')
        if (elementStatus && elementStatus.value) newStatusFilter = elementStatus.value
        if (elementPreferential && elementPreferential.value)
          newPreferentialFilter = elementPreferential.value
        if (elementTime && elementTime.value) newTimeFilter = elementTime.value

        const queuesRes = await GET(
          `/queueReservation/queue/${queueConfigId}?status=${newStatusFilter}&preferential=${newPreferentialFilter}&timeInitial=${
            newTimeFilter !== 'all' ? calcTimeSubstractHour(parseInt(newTimeFilter)) : newTimeFilter
          }`
        )
        if (queuesRes && queuesRes.data && queuesRes.data.length > 0) {
          const queuesData = queuesRes.data.map((queue: QueueType) => {
            const seconds =
              parseInt(queue.minutesOnQueue.split(':')[0]) * 3600 +
              parseInt(queue.minutesOnQueue.split(':')[1]) * 60 +
              parseInt(queue.minutesOnQueue.split(':')[2])
            queue.seconds = seconds
            return queue
          })
          const newQueuesData = [...queues]
          setLoadingNewData(true)
          queuesData.forEach((q: any) => {
            const find = queues.find((qq) => qq.id === q.id)
            if (!find) {
              newQueuesData.push(q)
            }
          })
          setLoadingNewData(false)
          setQueues(newQueuesData)
        } else {
          setQueues([])
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  async function initGetQueue() {
    // Simulando uma chamada assíncrona
    await getQueue()

    setTimeout(initGetQueue, 30000)
  }

  async function addCustomerQueue() {
    try {
      if (peopleNumber <= 0) {
        Swal.fire({
          customClass: {
            container: 'my-swal',
          },
          icon: 'warning',
          title: 'Atenção!',
          text: `Precisa haver uma pessoa ou mais para entrar na fila.`,
        })
        return
      }

      if (queueConfig && parseInt(peopleNumber.toString()) > queueConfig.limitPeopleGroup) {
        Swal.fire({
          customClass: {
            container: 'my-swal',
          },
          icon: 'warning',
          title: 'Atenção!',
          html: `Há mais pessoas do que o permitido na fila de espera (Máximo ${queueConfig.limitPeopleGroup})`,
        })
        return
      }

      if (!customerName) {
        Swal.fire({
          customClass: {
            container: 'my-swal',
          },
          icon: 'warning',
          title: 'Atenção!',
          text: `É necessário adicionar um nome para entrar na fila.`,
        })
        return
      }

      if (!customerName.split(' ')[1]) {
        Swal.fire({
          customClass: {
            container: 'my-swal',
          },
          icon: 'warning',
          title: 'Atenção!',
          text: `É necessário adicionar um sobrenome para entrar na fila.`,
        })
        return
      }

      if (!customerPhone || customerPhone.includes('_')) {
        Swal.fire({
          customClass: {
            container: 'my-swal',
          },
          icon: 'warning',
          title: 'Atenção!',
          text: `Celular inválido.`,
        })
        return
      }
      setLoading(true)
      const queueResponse = await POST('/queueReservation/queue', {
        people: parseInt(peopleNumber.toString()),
        name: customerName,
        phone: telephoneNoMask(customerPhone),
        preferential: preferentialQueue,
        subscription: null,
      })
      await getQueues()
      setLoading(false)

      if (!queueResponse || !queueResponse.success) {
        Swal.fire({
          customClass: {
            container: 'my-swal',
          },
          icon: 'error',
          title: 'Erro ao cadastrar cliente na fila!',
          text: 'Não foi possível cadastrar cliente na fila.',
        })
      } else {
        setCustomerName('')
        setCustomerPhone('')
        setPeopleNumber(0)
        setPreferentialQueue(false)

        Swal.fire({
          customClass: {
            container: 'my-swal',
          },
          icon: 'success',
          title: 'Sucesso!',
          text: 'Cadastrar do cliente na fila.',
        }).then(() => closeWrapperModal())
      }
    } catch (err: any) {
      let title = 'Erro ao entrar na fila!'
      let text = 'Não foi possível entrar na fila.'
      if (err && err.response && err.response.data && err.response.data.error) {
        title = err.response.data.error
      }
      if (err && err.response && err.response.data && err.response.data.message) {
        text = err.response.data.message
      }

      if (err && typeof err === 'string') {
        text = err.toString()
      }

      setLoading(false)
      Swal.fire({
        customClass: {
          container: 'my-swal',
        },
        icon: 'error',
        title,
        text,
      })
    }
  }

  async function exportCSV() {
    try {
      if (!startDate || !startHour || !finishDate || !finishHour) {
        Swal.fire({
          icon: 'warning',
          text: 'Preencha todos os campos',
          title: 'Falta campos',
        })
        return
      }

      setLoading(true)

      const dataInit = convertBrazilToUTC(`${startDate}T${startHour}`)
      const dataFin = convertBrazilToUTC(`${finishDate}T${finishHour}`)
      const queueResponse = await POST('/queueReservation/queue/filter_csv', {
        dataInit: dataInit,
        dataFin: dataFin,
      })
      setLoading(false)

      if (!queueResponse || !queueResponse.success) {
        Swal.fire({
          icon: 'error',
          text: 'Erro ao exportar CSV',
          title: 'Erro ao exportar CSV',
        })

        return
      }

      queueResponse.data.forEach((item: any) => {
        const parseDate = (dateString: string) => {
          const [datePart, timePart] = dateString.split(', ')
          const [day, month, year] = datePart.split('/')
          return new Date(`${year}-${month}-${day}T${timePart}`)
        }

        const horaChegada = parseDate(item['Hora de Chegada'])

        if (item['Hora de Entrada']) {
          const horaEntrada = parseDate(item['Hora de Entrada'])

          const difMs = horaEntrada.getTime() - horaChegada.getTime()

          const difSeg = Math.floor(difMs / 1000)

          // Calculando horas, minutos e segundos
          const hours = Math.floor(difSeg / 3600)
          const minutes = Math.floor((difSeg % 3600) / 60)
          const seconds = difSeg % 60

          // Formatando para Hora:Min:Seg
          const tempoEspera = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(
            2,
            '0'
          )}:${String(seconds).padStart(2, '0')}`

          item['Tempo de Espera'] = tempoEspera
        } else {
          item['Tempo de Espera'] = ''
        }
      })

      exportExcel(queueResponse.data, 'fila-espera')

      setFinishDate('')
      setFinishHour('')
      setStartDate('')
      setStartHour('')
    } catch (error) {
      setLoading(false)
      Swal.fire({
        icon: 'error',
        text: 'Erro ao exportar CSV',
        title: 'Erro ao exportar CSV',
      })
    }
  }

  async function editCustomerQueue() {
    try {
      if (!queueSelected || parseInt(queueSelected.id) <= 0) {
        Swal.fire({
          customClass: {
            container: 'my-swal',
          },
          icon: 'warning',
          title: 'Atenção!',
          text: `Reserva não encontrada.`,
        })
        return
      }

      if (peopleNumber <= 0) {
        Swal.fire({
          customClass: {
            container: 'my-swal',
          },
          icon: 'warning',
          title: 'Atenção!',
          text: `Precisa haver uma pessoa ou mais para entrar na fila.`,
        })
        return
      }
      setLoading(true)
      const queueResponse = await PUT(`/queueReservation/queue/${queueSelected.id}`, {
        people: parseInt(peopleNumber.toString()),
      })
      setLoading(false)

      if (!queueResponse || !queueResponse.success) {
        Swal.fire({
          customClass: {
            container: 'my-swal',
          },
          icon: 'error',
          title: 'Erro ao cadastrar cliente na fila!',
          text: 'Não foi possível cadastrar cliente na fila.',
        })
      } else {
        setQueueSelected(null)
        setCustomerName('')
        setCustomerPhone('')
        setPeopleNumber(0)
        setPreferentialQueue(false)

        const newQueue = queues.map((queue) => {
          if (queue.id === queueSelected.id) {
            queue.people = peopleNumber
          }

          return queue
        })

        setQueues(newQueue)

        Swal.fire({
          customClass: {
            container: 'my-swal',
          },
          icon: 'success',
          title: 'Sucesso!',
          text: 'Cliente na fila editado com sucesso.',
        }).then(() => closeWrapperModal())
      }
    } catch (err: any) {
      let title = 'Erro ao editar fila!'
      let text = 'Não foi possível editar  fila.'
      if (err && err.response && err.response.data && err.response.data.error) {
        title = err.response.data.error
      }
      if (err && err.response && err.response.data && err.response.data.message) {
        text = err.response.data.message
      }

      if (err && typeof err === 'string') {
        text = err.toString()
      }

      setLoading(false)
      Swal.fire({
        customClass: {
          container: 'my-swal',
        },
        icon: 'error',
        title,
        text,
      })
    }
  }

  useEffect(() => {
    init()
    // ✅ NÃO fazer busca automática ao carregar
    // Apenas buscar quando o usuário clicar em "Atualizar" ou quando confirmar uma alocação
    // Remover: fetchAllocations(timeRangeHours)
    // Remover: interval automático de 30s
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (queueConfigId) {
      initGetQueue()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queueConfigId])

  useEffect(() => {
    if (queueSelected) {
      setPeopleNumber(queueSelected.people)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queueSelected])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>{i18n.t(`queue.menage`)} </span>
                <BreadCrumbs />
              </h3>
              <Button
                text={i18n.t(`queue.add`)}
                color='primary'
                iconColor='#FFF'
                icon='fas fa-filter'
                size='small'
                horizontalPadding={6}
                btnAttr={{
                  type: 'button',
                }}
                click={() => {
                  setOption('add')
                  showWrapperModal(i18n.t(`queue.add`))
                }}
                btnClass='fw-bolder m-3'
              />
            </div>

            <div className='card-body d-flex flex-column gap-5'>
              <div className='d-flex align-items-center justify-content-start'>
                <div className='d-flex w-75 '>
                  <div className=' align-items-end  justify-content-start me-5 flex-grow-1'>
                    <span className='align-self-start'>Status</span>
                    <Input
                      inputAttr={{
                        type: 'select',
                      }}
                      idInput='status-filter-input'
                      options={[
                        {
                          value: 'all',
                          select: i18n.t('queue.all'),
                        },
                        {
                          value: 'queue',
                          select: i18n.t('queue.in_queue'),
                        },
                        {
                          value: 'confirmed',
                          select: i18n.t('queue.confirmed'),
                        },
                        {
                          value: 'removed',
                          select: i18n.t('queue.removed'),
                        },
                      ]}
                      placeholder={'Status'}
                      value={statusFilter}
                      change={(value: any) => setStatusFilter(value)}
                    />
                  </div>

                  <div className=' flex-grow-1 align-items-center me-5 justify-content-between'>
                    <span className='align-self-start'>{i18n.t('queue.preferential')}</span>
                    <Input
                      inputAttr={{
                        type: 'select',
                      }}
                      idInput='preferential-filter-input'
                      options={[
                        {
                          value: 'all',
                          select: i18n.t('queue.all'),
                        },
                        {
                          value: 'y',
                          select: i18n.t('queue.yes'),
                        },
                        {
                          value: 'n',
                          select: i18n.t('queue.no'),
                        },
                      ]}
                      placeholder={i18n.t('queue.preferential')}
                      value={preferentialFilter}
                      change={(value: any) => setPreferentialFilter(value)}
                    />
                  </div>

                  <div className=' flex-grow-1 align-items-center me-5 justify-content-between'>
                    <span className='align-self-start'>{i18n.t('queue.show')}</span>
                    <Input
                      inputAttr={{
                        type: 'select',
                      }}
                      idInput='time-filter-input'
                      options={[
                        {
                          value: 'all',
                          select: i18n.t('queue.all'),
                        },
                        {
                          value: '12',
                          select: i18n.t('queue.show_text').replace('@', '12'),
                        },
                        {
                          value: '24',
                          select: i18n.t('queue.show_text').replace('@', '24'),
                        },
                      ]}
                      placeholder={i18n.t('queue.preferential')}
                      value={timeFilter}
                      change={(value: any) => setTimeFilter(value)}
                    />
                  </div>
                  <div className='h-100 d-flex  align-self-end gap-4'>
                    <Button
                      text='Filtrar'
                      color='primary'
                      iconColor='#FFF'
                      icon='fas fa-filter'
                      size='small'
                      horizontalPadding={6}
                      btnAttr={{
                        type: 'button',
                      }}
                      click={async () => {
                        setLoading(true)
                        await getQueues()
                        setLoading(false)
                      }}
                      btnClass='mb-0 fw-bolder'
                    />
                    <Button
                      text='Exportar CSV'
                      color='success'
                      iconColor='#FFF'
                      icon='fa fa-download'
                      size='small'
                      horizontalPadding={6}
                      btnAttr={{
                        type: 'button',
                      }}
                      click={async () => {
                        setOption('export_csv')
                        showWrapperModal('Exportar Dados CSV')
                      }}
                      btnClass='mb-0 fw-bolder'
                    />
                  </div>
                </div>
              </div>
              <div className='d-flex flex-row w-full gap-5'>
                <Button
                  text={i18n.t(`queue.confirm_all`)}
                  color='primary'
                  iconColor='#FFF'
                  size='small'
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => updateAll('confirmed')}
                  btnClass='fw-bolder'
                />
                <Button
                  text={i18n.t(`queue.cancel_all`)}
                  color='primary'
                  iconColor='#FFF'
                  size='small'
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => updateAll('removed')}
                  btnClass='fw-bolder'
                />
              </div>
              {queues.length > 0 ? (
                queues.map((queue) => (
                  <QueueCard
                    queue={queue}
                    setQueueSelected={setQueueSelected}
                    setOption={setOption}
                    showWrapperModal={showWrapperModal}
                    limitMinutes={limitMinutes}
                    onProposeAllocation={openAllocationSelectionModal}
                  />
                ))
              ) : (
                <div className='d-flex flex-column w-100 gap-2 align-items-center'>
                  <h2 style={{color: '#2A2D36', fontWeight: '400'}}>{i18n.t(`queue.empty`)} :(</h2>
                </div>
              )}

              {/* Seção de Alocações - Mostrar se Gestão de Mesas estiver habilitada */}
              {queueConfig?.useTableManagement && (
                <div
                  style={{
                    marginTop: 32,
                    padding: 20,
                    border: '1px solid #D3D9E8',
                    borderRadius: 8,
                    backgroundColor: '#FAFBFC',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginBottom: 16,
                    }}
                  >
                    <h4
                      style={{
                        margin: 0,
                        color: '#2A2D36',
                        fontWeight: 600,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8,
                      }}
                    >
                      <Clock size={20} color='#4377FF' />
                      Mesas Alocadas (últimas {timeRangeHours}h ± próximas {timeRangeHours}h)
                    </h4>
                    <Button
                      text='Atualizar'
                      color='primary'
                      iconColor='#FFF'
                      icon='fas fa-sync'
                      size='small'
                      horizontalPadding={4}
                      btnAttr={{
                        type: 'button',
                      }}
                      click={() => fetchAllocations(timeRangeHours)}
                      btnClass='mb-0 fw-bolder'
                    />
                  </div>

                  {/* Filtro de intervalo de tempo */}
                  <div style={{marginBottom: 16, display: 'flex', gap: 8, alignItems: 'center'}}>
                    <label style={{fontSize: 13, color: '#6E7586', fontWeight: 500}}>
                      Intervalo de tempo:
                    </label>
                    <select
                      value={timeRangeHours}
                      onChange={(e) => {
                        const hours = parseInt(e.target.value)
                        setTimeRangeHours(hours)
                        fetchAllocations(hours)
                      }}
                      style={{
                        padding: '8px 12px',
                        border: '1px solid #D3D9E8',
                        borderRadius: 4,
                        fontSize: 13,
                        cursor: 'pointer',
                        backgroundColor: 'white',
                      }}
                    >
                      <option value={1}>1 hora antes/depois</option>
                      <option value={2}>2 horas antes/depois</option>
                      <option value={3}>3 horas antes/depois</option>
                      <option value={6}>6 horas antes/depois</option>
                      <option value={12}>12 horas antes/depois</option>
                    </select>
                  </div>

                  {/* Lista de alocações */}
                  <AllocationsList allocations={allocations} loading={loadingAllocations} />
                </div>
              )}
            </div>
          </div>
          <ModalWrapper
            zIndex={1000}
            confirmAction={() =>
              option === 'add'
                ? addCustomerQueue()
                : option === 'edit'
                ? editCustomerQueue()
                : option === 'export_csv'
                ? exportCSV()
                : changeQueue()
            }
            shouldCloseModal={option === 'add' || option === 'edit' ? false : true}
            textAction={
              option === 'add'
                ? i18n.t(`queue.add`)
                : option === 'edit'
                ? i18n.t(`queue.edit`)
                : option === 'removed'
                ? i18n.t(`queue.cancel_button`)
                : option === 'export_csv'
                ? 'Exportar CSV'
                : i18n.t(`queue.confirm_button`)
            }
          >
            {option === 'add' ? (
              <>
                <Input
                  inputAttr={{
                    type: 'defautl',
                  }}
                  placeholder='Nome do Cliente'
                  label={'Nome do Cliente'}
                  value={customerName}
                  change={(value: string) => {
                    // Verifica se contém apenas letras, espaços e acentos
                    const isValidName = /^[a-zA-ZÀ-ÿ\s]*$/.test(value)

                    // Só permite a alteração se for válido
                    if (isValidName) {
                      setCustomerName(value)
                    }
                  }}
                />
                <Input
                  inputAttr={{
                    type: 'tel',
                  }}
                  label={'Telefone do cliente'}
                  minNumber={0}
                  value={customerPhone}
                  change={(value: string) => {
                    setCustomerPhone(value)
                  }}
                />
                <Input
                  inputAttr={{
                    type: 'checkbox',
                  }}
                  placeholder='0'
                  label={'Fila Preferencial'}
                  value={preferentialQueue}
                  checked={preferentialQueue}
                  change={(value: boolean) => {
                    setPreferentialQueue(value)
                  }}
                />
                <Input
                  inputAttr={{
                    type: 'number',
                  }}
                  label={'Número de Pessoas na Fila'}
                  value={peopleNumber}
                  change={(value: number) => {
                    value >= 0 && setPeopleNumber(value)
                  }}
                />
              </>
            ) : (
              <>
                {option === 'edit' ? (
                  <Input
                    inputAttr={{
                      type: 'number',
                    }}
                    placeholder='0'
                    label={'Número de Pessoas na Fila'}
                    minNumber={0}
                    value={peopleNumber ? peopleNumber : ''}
                    change={(value: number) => {
                      setPeopleNumber(value)
                    }}
                    maxNumber={queueConfig?.limitPeople ? queueConfig?.limitPeople : 0}
                  />
                ) : (
                  <>
                    {option === 'export_csv' ? (
                      <>
                        <div className='d-flex gap-4'>
                          <Input
                            inputAttr={{
                              type: 'date',
                            }}
                            placeholder='Data de Inicio'
                            label={'Data de Inicio'}
                            value={startDate}
                            change={(value: string) => {
                              setStartDate(value)
                            }}
                          />
                          <Input
                            inputAttr={{
                              type: 'time',
                            }}
                            placeholder='Hora de Inicio'
                            label={'Hora de Inicio'}
                            value={startHour}
                            change={(value: string) => {
                              setStartHour(value)
                            }}
                          />
                        </div>
                        <div className='d-flex gap-4'>
                          <Input
                            inputAttr={{
                              type: 'date',
                            }}
                            placeholder='Data Final'
                            label={'Data Final'}
                            value={finishDate}
                            change={(value: string) => {
                              setFinishDate(value)
                            }}
                          />
                          <Input
                            inputAttr={{
                              type: 'time',
                            }}
                            placeholder='Hora Final'
                            label={'Hora Final'}
                            value={finishHour}
                            change={(value: string) => {
                              setFinishHour(value)
                            }}
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        <p className='my-6' style={{margin: 0, fontWeight: 400, fontSize: 14}}>
                          {option === 'removed'
                            ? i18n.t(`queue.cancel_text`)
                            : i18n.t(`queue.confirm_text`)}
                        </p>
                        {queueSelected && (
                          <>
                            <div
                              className='d-flex flex-row px-4 py-6 align-items-center'
                              style={{
                                border: '1px solid #D3D9E8',
                                borderLeft: '4px solid #D3D9E8',
                                borderRadius: 4,
                              }}
                            >
                              <div className='d-flex flex-column gap-2'>
                                <p style={{color: '#6E7586', margin: 0}}>
                                  <b style={{color: '#2A2D36'}}>{queueSelected.name}</b>
                                </p>
                                <p style={{color: '#6E7586', margin: 0}}>
                                  <b style={{color: '#2A2D36'}}>
                                    {queueSelected.people} {i18n.t(`queue.people`)}
                                  </b>
                                </p>
                                <p style={{color: '#6E7586', margin: 0}}>{queueSelected.phone}</p>
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </ModalWrapper>

          {/* MODAL DE SELEÇÃO: Ambiente e Horário */}
          {showAllocationSelectionModal && (
            <div
              className='position-fixed'
              style={{
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0,0,0,0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 2000,
              }}
              onClick={() => !loadingEnvironmentsHours && setShowAllocationSelectionModal(false)}
            >
              <div
                className='bg-white rounded'
                style={{
                  maxWidth: '600px',
                  width: '90%',
                  padding: '32px',
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <h3 className='mb-4'>
                  <i className='bi bi-calendar2-check me-2'></i>
                  Selecione Ambiente e Horário
                </h3>

                {loadingEnvironmentsHours ? (
                  <div className='text-center py-5'>
                    <div className='spinner-border text-primary' role='status'>
                      <span className='visually-hidden'>Carregando...</span>
                    </div>
                    <p className='mt-3 text-muted'>
                      Carregando ambientes e horários disponíveis...
                    </p>
                  </div>
                ) : (
                  <>
                    <div className='mb-4'>
                      <label className='form-label fw-600 mb-2'>Ambiente *</label>
                      <select
                        className='form-select'
                        value={allocationEnvironmentId || ''}
                        onChange={(e) => setAllocationEnvironmentId(parseInt(e.target.value))}
                        disabled={loadingEnvironmentsHours}
                      >
                        <option value=''>Selecione um ambiente...</option>
                        {environments.map((env) => (
                          <option key={env.id} value={env.id}>
                            {env.name} ({env.tables} mesas)
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className='mb-4'>
                      <label className='form-label fw-600 mb-2'>Horário *</label>
                      <select
                        className='form-select'
                        value={allocationBookingHourId || ''}
                        onChange={(e) => {
                          const hourId = e.target.value // Manter como string
                          setAllocationBookingHourId(parseInt(hourId)) // Parsear apenas para o state
                          // Armazenar o objeto completo da hora selecionada (comparar como string)
                          const selectedHour = bookingHours.find((h) => h.id.toString() === hourId)
                          setAllocationBookingHour(selectedHour || null)
                        }}
                        disabled={loadingEnvironmentsHours}
                      >
                        <option value=''>Selecione um horário futuro...</option>
                        {bookingHours.map((hour) => (
                          <option key={hour.id} value={hour.id}>
                            {hour.hour}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Explicação de uso */}
                    <div
                      style={{
                        marginBottom: 20,
                        padding: '12px 16px',
                        backgroundColor: '#E7F3FF',
                        borderLeft: '4px solid #4377FF',
                        borderRadius: 4,
                      }}
                    >
                      <p
                        style={{
                          margin: 0,
                          fontSize: 13,
                          color: '#2A2D36',
                          lineHeight: '1.6',
                          marginBottom: 8,
                        }}
                      >
                        <strong>ℹ️ Como funciona:</strong>
                      </p>
                      <ul
                        style={{
                          margin: 0,
                          paddingLeft: 20,
                          fontSize: 13,
                          color: '#2A2D36',
                          lineHeight: '1.6',
                        }}
                      >
                        <li>
                          Você selecionou o <strong>ambiente</strong> e <strong>horário</strong>{' '}
                          para alocar esta posição da fila
                        </li>
                        <li>
                          O sistema buscará mesas disponíveis{' '}
                          <strong>a partir do horário selecionado</strong>
                        </li>
                        <li>
                          Se não encontrar mesas naquele horário, procurará em horários{' '}
                          <strong>até 2 horas adiante</strong>
                        </li>
                        <li>
                          As propostas serão organizadas por <strong>melhor eficiência</strong>{' '}
                          (menor desperdício de assentos)
                        </li>
                      </ul>
                    </div>

                    <div className='d-flex gap-3 justify-content-end'>
                      <button
                        type='button'
                        className='btn btn-light'
                        onClick={() => setShowAllocationSelectionModal(false)}
                        disabled={loadingEnvironmentsHours}
                      >
                        Cancelar
                      </button>
                      <button
                        type='button'
                        className='btn btn-primary'
                        onClick={proposeTableAllocation}
                        disabled={
                          !allocationEnvironmentId ||
                          !allocationBookingHourId ||
                          loadingEnvironmentsHours
                        }
                      >
                        Propor Alocações
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          )}

          {/* MODAL DE PROPOSTAS: Resultado de mesas disponíveis */}
          {showAllocationModal && (
            <div
              className='position-fixed'
              style={{
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0,0,0,0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 2000,
              }}
              onClick={() => !loadingAllocation && setShowAllocationModal(false)}
            >
              <div
                className='bg-white rounded'
                style={{
                  maxWidth: '900px',
                  width: '90%',
                  maxHeight: '80vh',
                  overflowY: 'auto',
                  padding: '24px',
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <div className='d-flex justify-content-between align-items-center mb-4'>
                  <h3 className='mb-0'>
                    <i className='bi bi-table me-2'></i>
                    Selecione a Alocação de Mesas
                  </h3>
                  <button
                    type='button'
                    className='btn-close'
                    onClick={() => !loadingAllocation && setShowAllocationModal(false)}
                    disabled={loadingAllocation}
                  ></button>
                </div>

                {loadingAllocation ? (
                  <div className='text-center py-5'>
                    <div className='spinner-border text-primary' role='status'>
                      <span className='visually-hidden'>Carregando...</span>
                    </div>
                    <p className='mt-3 text-muted'>Procurando as melhores opções de alocação...</p>
                  </div>
                ) : allocationError ? (
                  <div
                    className='alert alert-danger'
                    role='alert'
                    style={{position: 'relative', zIndex: 1060}}
                  >
                    <h4 className='alert-heading'>Erro na Alocação</h4>
                    <p>{allocationError}</p>
                    <hr />
                    <button
                      className='btn btn-sm btn-danger'
                      onClick={() => {
                        setAllocationError(null)
                        setShowAllocationModal(false)
                      }}
                    >
                      Fechar
                    </button>
                  </div>
                ) : allocationProposals.length === 0 ? (
                  <div className='alert alert-info' role='alert'>
                    <p className='mb-0'>Nenhuma proposta de alocação disponível no momento.</p>
                  </div>
                ) : (
                  <>
                    <div className='row g-3 mb-4'>
                      {allocationProposals.map((proposal, index) => (
                        <div key={index} className='col-md-6'>
                          <div
                            className='card h-100'
                            style={{
                              cursor: 'pointer',
                              border:
                                selectedProposal === index
                                  ? '2px solid #4377FF'
                                  : '1px solid #D3D9E8',
                              backgroundColor: selectedProposal === index ? '#F8F9FF' : '#FFFFFF',
                              transition: 'all 0.3s ease',
                            }}
                            onClick={() => setSelectedProposal(index)}
                          >
                            <div className='card-body'>
                              <div className='d-flex justify-content-between align-items-start mb-3'>
                                <div>
                                  <h5 className='card-title mb-2'>
                                    Opção {index + 1}
                                    {selectedProposal === index && (
                                      <i
                                        className='bi bi-check-circle-fill ms-2'
                                        style={{color: '#4377FF'}}
                                      ></i>
                                    )}
                                  </h5>
                                  {proposal.badge && (
                                    <span
                                      className='badge'
                                      style={{
                                        backgroundColor: proposal.badge.includes('Ideal')
                                          ? '#3FB669'
                                          : proposal.badge.includes('Muito Bom')
                                          ? '#4377FF'
                                          : proposal.badge.includes('Bom')
                                          ? '#6C7A99'
                                          : proposal.badge.includes('Mais Desperdício')
                                          ? '#FFA500'
                                          : '#D3D9E8',
                                        color: proposal.badge.includes('Desperdício')
                                          ? '#FFF'
                                          : '#FFF',
                                      }}
                                    >
                                      {proposal.badge}
                                    </span>
                                  )}
                                </div>
                                <span className='badge bg-primary-light text-primary'>
                                  Score: {proposal.score?.toFixed(1) || '0'}
                                </span>
                              </div>

                              <div className='d-flex flex-column gap-2'>
                                <div>
                                  <small className='text-muted'>Ambiente</small>
                                  <p className='mb-1 fw-bold'>
                                    <i className='bi bi-building me-2'></i>
                                    {proposal.environmentName || 'Desconhecido'}
                                  </p>
                                </div>

                                <div>
                                  <small className='text-muted'>Mesas Alocadas</small>
                                  <p className='mb-1 fw-bold'>
                                    <i className='bi bi-diagram-3 me-2'></i>
                                    {proposal.tableIds?.length || 0} mesa(s)
                                  </p>
                                  <small style={{color: '#4377FF', fontWeight: '600'}}>
                                    {proposal.tableNumbers?.length > 0
                                      ? `Mesas: ${proposal.tableNumbers.join(', ')}`
                                      : 'IDs: ' + (proposal.tableIds?.join(', ') || 'N/A')}
                                  </small>
                                </div>

                                <div>
                                  <small className='text-muted'>Capacidade Total</small>
                                  <p className='mb-1 fw-bold'>
                                    <i className='bi bi-people me-2'></i>
                                    {proposal.totalCapacity || 0} lugar(es)
                                  </p>
                                </div>

                                <div>
                                  <small className='text-muted'>Desperdício de Espaço</small>
                                  <p
                                    className='mb-1 fw-bold'
                                    style={{
                                      color:
                                        (proposal.wastePercentage || 0) > 30
                                          ? '#DC3545'
                                          : '#28A745',
                                    }}
                                  >
                                    <i className='bi bi-graph-up me-2'></i>
                                    {proposal.wastePercentage?.toFixed(1) || '0'}%
                                  </p>
                                  <small style={{color: '#4377FF', fontWeight: '600'}}>
                                    ({proposal.availableSeats || 0} lugar(es) vago(s))
                                  </small>
                                </div>

                                <div className='mt-2 pt-2 border-top'>
                                  <small className='text-muted'>Ambiente</small>
                                  <p className='mb-0 fw-bold'>
                                    <i className='bi bi-building me-2'></i>
                                    {proposal.environmentLabel ||
                                      `${proposal.environmentId} - Desconhecido`}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    <div className='d-flex gap-2 justify-content-end pt-3 border-top'>
                      <button
                        className='btn btn-secondary'
                        onClick={() => setShowAllocationModal(false)}
                        disabled={loadingAllocation}
                      >
                        Cancelar
                      </button>
                      <button
                        className='btn btn-primary'
                        onClick={confirmTableAllocation}
                        disabled={loadingAllocation || selectedProposal === null}
                      >
                        {loadingAllocation ? (
                          <>
                            <span
                              className='spinner-border spinner-border-sm me-2'
                              role='status'
                              aria-hidden='true'
                            ></span>
                            Confirmando...
                          </>
                        ) : (
                          <>
                            <i className='bi bi-check-lg me-2'></i>
                            Confirmar Alocação
                          </>
                        )}
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </>
  )
}

const Queue: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {title: i18n.t(`queue.menage`), path: 'queue', isActive: true},
        ]}
      >
        {i18n.t(`queue.menage`)}
      </PageTitle>
      <QueueContent />
    </>
  )
}

export {Queue}
